<template>
  <Template>
    <Testimonials />
  </Template>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import Template from "@/components/Templates/index.vue";
import Testimonials from "@/components/Testimonials/Template1/index.vue";

export default defineComponent({
  components: {
    Template,
    Testimonials,
  },
});
</script>
